import { Controller } from "@hotwired/stimulus";
import { internalApiClient } from "../src/libs/axios/internalApiClient";
import { showFlashMessage } from "../src/utils/flashMessage";
import axios, { AxiosError } from "axios";

export default class extends Controller {
  static targets = ["statusSelect", "entryBlock"];

  declare readonly statusSelectTarget: HTMLSelectElement;
  declare readonly entryBlockTarget: HTMLElement;

  async change() {
    const entryKey = this.statusSelectTarget.getAttribute("data-job-entry-status-entry-key");
    const status = this.statusSelectTarget.value;

    try {
      await internalApiClient.patch(`/api/internal/v1/job_entries/${entryKey}/update_hiring_status`, {
        hiring_status: status,
      });

      // ステータスが「不採用」の場合、クラスを追加
      if (status === "rejected") {
        this.entryBlockTarget.classList.add("is_rejected");
      } else {
        this.entryBlockTarget.classList.remove("is_rejected");
      }

      // フラッシュメッセージを表示
      showFlashMessage("success", "ステータスを変更しました！");
    } catch (error) {
      console.error(error);
      let errorMessage = "ステータスの変更に失敗しました。再度実行してください";

      // Axiosエラーの場合
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<any>;
        if (axiosError.response?.data?.errors) {
          // APIからのエラーメッセージがある場合
          errorMessage = axiosError.response.data.errors.join(", ");
        } else if (axiosError.response?.status === 401) {
          errorMessage = "権限がありません。再ログインしてください";
        } else if (axiosError.response?.status === 404) {
          errorMessage = "応募データが見つかりません";
        }
      }

      showFlashMessage("error", errorMessage);
    }
  }
}
